module.exports = __webpack_public_path__ + "img/hipushit_yes.29893d5a.png";